
require('./topic.less');
require('../../components/tag/index.less');

__webpack_public_path__ = window.pageConfig.assets + '/';

require('../../app/app');
var i18n = require('i18n');

var isMobile = false;
var answered = '';
if (window.innerWidth < 700) {
  isMobile = true
  $('.wy-header .wy-header-nav').html(` <a style="font-size: 16px; " class="forum leaf-node" onclick="location.href='//forum.wuyuan.io'"><i style="" class="far fa-comments"></i> ${i18n('wy')}</a>`) 
    .css({display: 'inline-block'});
}



var util = require('../../app/util');
var doAjax = require('./ajax');
var marked = require('../../app/markdown');
var gotoTop = require('../../components/top');

var pageConfig = window.pageConfig;
pageConfig.user = pageConfig.user || {
  avatar: util.defaultAvatar
};
var isAdmin = pageConfig.admin;
var myid = pageConfig.loginUser.id;
var isMyself = pageConfig.user.id === myid;
var topicId = location.pathname.substring(location.pathname.lastIndexOf('/') + 1);




pageConfig.topic.create = util.handleDate(pageConfig.topic.create);
pageConfig.topic.unlock = pageConfig.topic.state === 1; ///
pageConfig.topic.title = pageConfig.topic.title.replace(/&lt;/g, '<').replace(/&gt;/g, '>')

var editorId = 'add-comment';
var wrapper = require('./main.html');
var plate = location.pathname.match(/^\/plate\/([^/]+)/);
plate = plate ? plate[1] : pageConfig.defaultPlate;
$('body').append(wrapper({
  otherTopic: pageConfig.otherTopic.map(function (item) {
    item.plate = plate;
    item.title = item.title.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    return item;
  }),
  topicTypeValue: pageConfig.topicType ? pageConfig.topicType[pageConfig.topic.type] : '',
  topic: pageConfig.topic,
  user: pageConfig.user,
  markdown: true,
  markcheck: true,
  tinymce: true,
  lines: 15,
  hideCommentTitle: !pageConfig.comment.length,
  id: editorId
}));
if (pageConfig.topic.editorType === 'markdown') {
  $('.content-wrap').addClass('markdown-body');
  if (!location.host.match(/\.io$/)) {
    $('code').addClass('hljs');
  }
}

if (!myid) {
  $('.editor-mask').show().click(redirect);
}


//编辑帖子
var editTopicLayer = require('./editTopicLayer');
editTopicLayer( function (res, data) {
  pageConfig.markdown = pageConfig.markdown ? data.content : '';
  
  var content = pageConfig.markdown ? marked.render(data.content) : data.content;

  if (pageConfig.topic.title != data.title) {
    pageConfig.topic.title = data.title;
    $('.topic-title-wrap .topic-title span').text(data.title);
  }
  
  if (pageConfig.topic.type != data.type) {
    $('.topic-title-wrap .topic-title a').text(i18n(data.type))
    pageConfig.topic.type = data.type;
  }
  
  $('.topic-content .content-wrap').html(content);
  if (pageConfig.markdown) {
    pageConfig.markdown = data.content;
  } else {
    pageConfig.topic.content = content;
  }
  
  if (data.tags) {
    if (pageConfig.topic.tags.join(',') !== data.tags) {
      pageConfig.topic.tags  =  data.tags.split(',');
      var html = '';
      pageConfig.topic.tags.forEach(function(item) {
        html += '<a class="ui label transition visible tag-item">' + item.replace(/</g, '&lte;') + '<a>';
      });
      $('.tag-list').html(html);
    }
  } else {
    $('.tag-list').html('');
    pageConfig.topic.tags = [];
  }
});

$('.tag-list').on('click', '.tag-item', function (e) {
  var tag = $(e.target).text().trim();
  window.open('/plate/' + plate + '/tags/' + tag);
})


//回复,编辑评论
var replyToLayer = require('./replyToLayer');
replyToLayer( function (res, data, mode) {
  var parent = $('[data-cid=' + data.cid +']').parent();
  
  if (mode == 'edit') {
    if (data.editorType === 'markdown') {
      data.markdown = data.content;
      data.content = marked.render(data.content);
    }
    pageConfig.comment.some(function (item) {
      if (item._id === data.cid) {
        item.markdown = data.markdown;
        item.content = data.content;
        return true;
      }
    });
    parent.children('.comment-content').children('.comment-self').html(data.content);
  } else {
    var replyData = {
      uid: myid,
      create: new Date,
      editorType: res.editorType,
      content: data.content,
      _id: res.cid,
      praiser: [],
      replyTo: data.cid
    };
    pageConfig.users[myid] = pageConfig.users[myid] || pageConfig.loginUser;

    var html = renderTree([replyData], 0);
    pageConfig.comment.unshift(replyData);
    var subList = parent.children('.sub-list');
    if (subList.length) {
      subList.prepend(html);
    } else {
      parent.append('<ul class="sub-list">' + html + '</ul>');
    }
  }
});



//isAdmin = true; /////

;(function () {
  var hasTool;
  var praiser = pageConfig.topic.praiser || [];
  var praised = false; //我是否赞了 帖子
  praiser.some(function (it) {
    if (it === myid) {
      praised = true;
      return true;
    }
  });

  if (isAdmin || isMyself) { //编辑帖子
    var unlock = pageConfig.topic.unlock;
    var praise = `<i title="${i18n(praised ? 'unpraise' : 'praise')}" style="margin-right: 0; cursor: default;" class="thumbs outline up icon ${praised ? 'active' : ''} ${pageConfig.topic.unlock ? '' : 'disabled'}">
      </i><span class="up-num ${praised ? 'active' : ''}">${praiser.length}</span>`; 
    var icons = `<div title="${i18n('common.edit')}" class="topic-edit-wrap">
      <i class="edit icon ${unlock ? '' : 'disabled'}"></i>
      ${praise}
    </div>`;
    $('.topic-content').append(icons);

    $('.topic-edit-wrap').on('click', '.edit', function () {//编辑帖子
      if ($(this).hasClass('disabled')) {
        return;
      }
      var layer = $('.edit-topic-layer');
      var type = pageConfig.topic.type;  
      layer.find('[name=title]').val(pageConfig.topic.title);
      layer.find('.tab-list .active').removeClass('active');
      layer.find('.tab-list [data-type=' + type + ']').addClass('active');

      if (pageConfig.markdown) {
        layer.find('.markdown-editor').val(pageConfig.markdown);
        layer.find('.markdown-field, .markdown-op').show();
      } else {
        tinyMCE.get('tinymce-edit-topic').setContent(pageConfig.topic.content);//
        pageConfig.topic.content = tinyMCE.get('tinymce-edit-topic').getContent({ format: "raw"});
        window.enhancerScrollTop = window.pageYOffset;
        window.scrollTo(0, 0);
      }
      $('input[name=tags]').importTags(pageConfig.topic.tags.join(','))
      layer.modal('show');
    });
    hasTool = true;
  }

  if (myid && !isMyself) {
    var star = pageConfig.topic.collectors.some(function(item) {
      return item === myid;
    });
    
    praise = isAdmin ? '' : `<i title="${i18n(praised ? 'unpraise' : 'praise')}" style="margin-right: 0;" class="thumbs outline up icon ${praised ? 'active' : ''} ${pageConfig.topic.unlock ? '' : 'disabled'}">
      </i><span class="up-num ${praised ? 'active' : ''}">${praiser.length}</span>`; 
    var icons = `<i title="${i18n(star ? 'unstar' : 'star')}" class="full ${star ?  '' : 'empty'}  star icon"></i>
      ${praise}
    `;

    if (hasTool) {
      $('.topic-content .topic-edit-wrap').append(icons);
    } else {
      icons = `<div class="topic-edit-wrap">${icons}</div>`;
      $('.topic-content').append(icons);
    }
    
    $('.topic-edit-wrap').on('click', '.star', function () {// 收藏帖子
      var self = this;
      doAjax('collect', {tid: topicId, collect: $(this).hasClass('empty')}, function () {
        $(self).toggleClass('empty');
        $(self).prop('title', i18n($(self).hasClass('empty') ? 'star' : 'unstar'));
      });
    });

    $('.topic-edit-wrap').on('click', '.thumbs', function () {// 赞
      var self = this;
      if ($(this).hasClass('disabled')) {
        return;
      }

      var thumbs = $(self).parent().find('.thumbs');
      doAjax('praiseTopic', {tid: topicId, praise: !thumbs.hasClass('active')}, function (res) {
        var upnum = $(self).parent().find('.up-num');
        thumbs.toggleClass('active');
        upnum.toggleClass('active');

        var add = thumbs.hasClass('active');
        var num = parseInt(upnum.text(), 10) || 0;
        num += add ? 1 : -1;
        num = num > 0 ? num : 0;
        upnum.text(num);
        
        $(self).prop('title', i18n(add ? 'unpraise' : 'praise'))
      });
    });
  }
})();




if (isAdmin) { // lock & top & essence
  require.ensure(['./admin'], function (require) {
    require('./admin');
  }, 'admin');
} else if ( pageConfig.topic.state === 2) {
  $('.topic-edit-wrap').append('<i title="locked" class="lock icon" style="cursor: default"></i>');
}

function redirect () {
  var suf = location.host.split('.');
  suf = suf[suf.length - 2] + '.' + suf[suf.length - 1];
  window.location = '//login.' + suf + '/?callbackUrl=' + location.href;
}
$('.add-comment').click( function (e) {//添加评论
  e.preventDefault();
  
  if (!myid) {
    return redirect();
  }

  if ($(this).hasClass('disabled')) {
    return;
  }

  var isHtml = !$('.my-comment .markdown-layer input[name=editorType]').prop('checked');
  var content = isHtml ? tinyMCE.get('tinymce-' + editorId).getContent({ format: "raw"}) : $('.my-comment .markdown-editor').val();
  
  
  if (isHtml) {
    var validateContent = tinyMCE.get('tinymce-' + editorId).getContent({ format: "text"});

    if (validateContent.length < pageConfig.topicContent.min) {
      if (!content.match(/<img/)) {
        util.show(i18n('content.length'));
        return;
      }
    } 

    if (validateContent.length > pageConfig.topicContent.max) {
      return util.show(i18n('tip.content.length', {min: pageConfig.topicContent.min, max: pageConfig.topicContent.max}))
    }
  } else {
    if (content.length < pageConfig.topicContent.min) {
      util.show(i18n('content.length'));
      return;
    }

    if (content.length > pageConfig.topicContent.max) {
      return util.show(i18n('tip.content.length', {min: pageConfig.topicContent.min, max: pageConfig.topicContent.max}))
    }
  }
  

  if (!isHtml) {
     content = content.replace(new RegExp('</script>', 'gm'), '&lt;/script>');
  }
  var data = {
    content: content.replace(/data-mce-src="[^"]+"/g, ''),
    editorType: isHtml ? 'html' : 'markdown',
    tid: topicId
  };

  util.uploadImage(data.content, isHtml ? 'html' : 'markdown', function (content) {
    data.content = content || data.content;
    
    doAjax('addComment', data, function (res) {
      if (isHtml) {
        tinyMCE.get('tinymce-' + editorId).setContent('');
      } else {
        $('.my-comment .markdown-editor').val('');
      }
      
      if (res.data.cid) {
        var comment = {
          _id: res.data.cid,
          uid: myid,
          create: new Date,
          content: data.content,
          editorType: isHtml ? 'html' : 'markdown',
          praiser: []
        }
        pageConfig.users[myid] = pageConfig.loginUser;
        var html = renderTree([comment], 0);
        pageConfig.comment.unshift(comment);
        $('.comment-list').eq(1).prepend(html).removeClass('hide');
        $('.comment-list-title').eq(1).removeClass('hide');

      } 
    });
  });
});


$('body').on('click', '.forum-main img', function () {
  var view = $('.img-view');
  var vw = Math.floor(window.innerWidth * 0.9);
  var vh = Math.floor(window.innerHeight * 0.9);
  var nw = this.naturalWidth;
  var nh = this.naturalHeight;
  view.find('img').remove();

  if (vw / vh < nw / nh) {
    var max = Math.max(vw, nw);
    vw = vw > nw ? nw : vw;
    view.append('<img data-dim="width" data-max="' + max + '" src="' + this.src + '" style="width:' + vw + 'px" />');
  } else {
    var max =  Math.max(vh, nh);
    vh = vh > nh ? nh : vh;
    view.append('<img data-dim="height" data-max="' + max + '" src="' + this.src + '" style="height:' + vh + 'px" />');
  }
  view.css('display', 'flex');
  $('.img-view-mask').show();
});
$('body').on('click', '.img-view', function () {
  $('.img-view').css('display', 'none');
  $('.img-view-mask').css('display', 'none');
});
$('body').on('keyup', function (e){
  if (e.keyCode == 27) {
    $('.img-view').click();
  }
});

function scale (plus) {
  var view = $('.img-view img');
  var max = view.data('max');
  var min = 100;
  var dim = view.data('dim');
  var step =  Math.floor((max - min) / 10);
  var cur = parseInt(view.css(dim), 10);
  cur = plus ?  cur + step :  cur - step;
  view.css(dim, plus ? Math.min(max, cur) : Math.max(min, cur));
}
$('body').on('click', '.img-view .plus', function (e) {
  e.preventDefault();
  e.stopPropagation();
  scale(true);
});
$('body').on('click', '.img-view .minus', function (e) {
  e.preventDefault();
  e.stopPropagation();
  scale(false);
});

$('body').on('click', '.img-tool', function (e) {
  e.preventDefault();
  e.stopPropagation();
})


pageConfig.commentMap = {
  root: []
};
function buildTree (comments) {
  var commentMap = pageConfig.commentMap;
  var maps = {};
  comments.forEach((item) => {
    maps[item._id] = true;
  });

  comments.forEach(function (item) {
    if (item.replyTo && maps[item.replyTo]) {
      commentMap[item.replyTo] = commentMap[item.replyTo] || [];
      commentMap[item.replyTo].push(item);
    } else {
      commentMap.root.push(item);
    }

    if (commentMap[item._id]) {
      item.children = item.children || commentMap[item._id];
    } else {
      commentMap[item._id] = commentMap[item._id] || [];
      item.children = commentMap[item._id];
    }
  })
}
var maxLevel = isMobile ? 1 : Math.ceil(($('.forum-main').width() - 580) / 40);


function renderTree(arr, level, pnick) {
  var users = pageConfig.users;
  var html = '';
  arr.forEach(function (item) {
    var user = users[item.uid] || {
      avatar: util.defaultAvatar
    };

    var create = util.handleDate(item.create);
    item.edit =  user.id == myid || isAdmin;
    item.lock = !pageConfig.topic.unlock;

    if (item.editorType === 'markdown') {
      item.markdown = item.content;
      item.content = marked.render(item.content);
    }

    var praised = false; //我是否赞了该评论
    item.praiser.some(function (it) {
      if (it === myid) {
        praised = true;
        return true;
      }
    });

    var login = !!myid;
    if (login) {
      var ttype = pageConfig.topic.type;
      var needAnswer = !!(myid && (ttype === 'question' || ttype === 'widget') && (isAdmin || isMyself) && !pageConfig.topic.answer);
      var disabled = item.lock ? 'disabled' : '';
      var active = praised ? 'active' : '';
      login = '<div class="comment-edit-wrap clearfix" data-cid="' + item._id + '" data-name="' + user.nickname + '">\
        ' + (needAnswer ? '<div class="ui button current-answer">' + i18n('make.answer') + '</div>' : '') + '\
      <div style="float: right;">';
      login += '<i title="' + i18n(praised ? 'unpraise' : 'praise') + '" style="margin-right: 0;" class="thumbs outline up icon ' + active + disabled  + '"></i>'
      login += '<span class="up-num ' + active + '">' + item.praiser.length + '</span>'
      login += '<i title="' + i18n('common.reply') + '" class="talk icon ' + disabled + '"></i>';
      if (item.edit) {
        login += '<i title="' + i18n('common.edit') +'" class="edit icon ' + disabled + '"></i>';
        login += '<i title="' + i18n('common.remove') + '" class="trash outline icon ' + disabled + '"></i>';
      }
      
      if (ttype === 'question' || ttype === 'widget') {
        if (pageConfig.topic.answer == item._id) {
          answered = '<div style="left: 5px;" class="resolved-wrap"><i title="' + i18n('top.answer') + '" class="resolved check icon"></i><div class="resolved-text">' + i18n('answered') + '</div></div>';
        } else if ((isAdmin || isMyself) && !pageConfig.topic.answer) {
          login += '<i title="' + i18n('make.answer') + '" class="answer check square icon"></i>';
        }
      }
      if (isAdmin && pageConfig.topic.type === 'bug' && !pageConfig.topic.answer) {
        if (pageConfig.topic.answer !== item._id) {
          login += '<i title="' + i18n('make.answer') + '" class="answer check square icon"></i>';
        }
      }
      
      login += '</div></div>';
    } else {
      login = ''; //// like
    }

    var children = '';
    if (item.children && item.children.length) {
      children = renderTree(item.children, level + 1, user.nickname);
    }

    

    html += '<li id="' + item._id + '" class="clearfix comment-item">\
      <img class="avatar" src="' + user.avatar + '" alt="avatar">\
      <div class="list-item">\
        <div class="title-user">\
          <span class="username">' + user.nickname + '</span> <span class="pub-date" title="' + create.tip + '">' + create.text + '</span> <span style="margin-left: 10px;">' + (pnick ? '@' + pnick : '') + '</span>\
        </div>\
        <div class="comment-content">\
          <div class="comment-self">' + item.content + '\
          </div>\
        </div>' + login + (level < maxLevel && children ? '<ul class="sub-list">' + children + '</ul>'  : '') + '\
      </div>\
    </li>';

    if (level > maxLevel - 1) {
      html += children;
    }
    if (pageConfig.topic.answer == item._id) {
      answered = '<li style="padding-left: 10px; border-bottom: 0;"  class="clearfix comment-item">\
        <img style="left: 5px;" class="avatar" src="' + user.avatar + '" alt="avatar">' + answered + '\
        <div class="list-item">\
          <div class="title-user">\
            <span class="username">' + user.nickname + '</span> <span class="pub-date" title="' + create.tip + '">' + create.text + '</span>\
          </div>\
          <div class="comment-content">\
            <div class="comment-self" style="min-height: 50px;">' + item.content + '\
            </div>\
          </div>\
        </div>\
      </li>'
    }
  });

  return html
}

;( function () {//评论列表
  
  var users = pageConfig.users;
  pageConfig.comment.reverse();
  buildTree(pageConfig.comment);
  if (pageConfig.commentMap.root && pageConfig.commentMap.root.length > 0) {
    $('.comment-list').html(renderTree(pageConfig.commentMap.root, 0))
  } else {
    $('.comment-list').addClass('hide');
  }

  $('.comment-list').on('click', '.comment-edit-wrap .talk', function () {//回复
    var parent = $(this).closest('.comment-edit-wrap');
    var cid = parent.data('cid');
    var name = parent.data('name');
    var layer = $('.reply-to-layer');

    if ($(this).hasClass('disabled')) {
      return;
    }

    var checkboxWrap = layer.find('.ui.checkbox');
    if (checkboxWrap.find('input').prop('checked')) {
      checkboxWrap.find('input').click();
    }
    checkboxWrap.show();
    layer.find('.reply-user').text(name);
    layer.find('.header').text(i18n('reply.topic'))
    window.enhancerScrollTop = window.pageYOffset;
    window.scrollTo(0, 0);
    layer.modal('show');
    layer.find('.submit').data('cid', cid).data('mode', 'add');
  });
  $('.comment-list').on('click', '.comment-edit-wrap .edit', function () {//编辑评论
    var parent = $(this).closest('.comment-edit-wrap');
    var cid = parent.data('cid');
    var name = parent.data('name');
    var layer = $('.reply-to-layer');

    if ($(this).hasClass('disabled')) {
      return;
    }

    layer.find('.reply-user').text(name);
    layer.find('.header').text(i18n('edit.comment'));
    
    var itemData;
    pageConfig.comment.some(function (item) {
      if (item._id === cid) {
        itemData = item;
        return true;
      }
    });

    var checkboxWrap = layer.find('.ui.checkbox');
    checkboxWrap.hide();

    if (itemData) {
      if (itemData.editorType === 'markdown') {
        if (!checkboxWrap.find('input').prop('checked')) {
          checkboxWrap.find('input').click();
        }
        layer.find('.markdown-editor').val(itemData.markdown);
      } else {
        if (checkboxWrap.find('input').prop('checked')) {
          checkboxWrap.find('input').click();
        }
        tinyMCE.get('tinymce-reply-to').setContent($(this).closest('li').find('.comment-self').html())
      }

      window.enhancerScrollTop = window.pageYOffset;
      window.scrollTo(0, 0);
      
      layer.modal('show');
      layer.find('.submit').data('cid', cid).data('mode', 'edit').data('editor', itemData.editorType);
    } else {
      console.error(cid)
    }
  });
  $('.comment-list').on('click', '.comment-edit-wrap .thumbs', function () {// 赞
    var cid = $(this).closest('.comment-edit-wrap').data('cid');
    var self = this;
    if ($(this).hasClass('disabled')) {
      return;
    }

    var thumbs = $(self).parent().find('.thumbs');
    doAjax('praiseComment', {tid: topicId, cid: cid, praise: !thumbs.hasClass('active')}, function (res) {
      var upnum = $(self).parent().find('.up-num');
      thumbs.toggleClass('active');
      upnum.toggleClass('active');

      var add = thumbs.hasClass('active');
      var num = parseInt(upnum.text(), 10) || 0;
      num += add ? 1 : -1;
      num = num > 0 ? num : 0;
      upnum.text(num);
      
      $(self).prop('title', i18n(add ? 'unpraise' : 'praise'))
    });
  });
  
  $('.comment-list').on('click', '.comment-edit-wrap .trash', function () { //删除评论
    var cid = $(this).closest('.comment-edit-wrap').data('cid');
    var self = this;
    if ($(this).hasClass('disabled')) {
      return;
    }
    util.showConfirm(i18n('confirm.remove.comment'), function () {
      doAjax('removeComment', {tid: topicId, cid: cid}, function () {
        //$(self).closest('li').remove();
        window.location.reload();
      });
    });
  });

  $('.comment-list').on('click', '.comment-edit-wrap .answer', function () {//设为答案
    var cid = $(this).closest('.comment-edit-wrap').data('cid');
    var self = this;
    if ($(this).hasClass('disabled') || pageConfig.topic.answer) {
      return;
    }

    util.showConfirm(i18n('confirm.answer'), function () {
      
      
      doAjax('answerComment', {tid: topicId, cid: cid}, function () {
        var resolved = $('.resolved');
        if (resolved.length) {
          var answer = '<i title="' + i18n('make.answer') + '" class="answer check square icon"></i>';
          resolved.next('.list-item').children('.comment-edit-wrap').children('div').append(answer);
          resolved.remove();
        }
        $(self).closest('.list-item').before(`<div class="resolved-wrap">
          <i title="${i18n('top.answer')}" class="resolved check icon"></i>
          <div class="resolved-text">${i18n('answered')}</div>
        </div>`);
        $('.comment-list .comment-edit-wrap .answer').remove();
        pageConfig.topic.answer = cid;
        $('.comment-list').off('mouseover').off('mouseout').find('.current-answer').remove();
      });
    });
  });


  

  
  function selectText(text) {
    if (document.body.createTextRange) {
      var range = document.body.createTextRange();
      range.moveToElementText(text);
      range.select();
    } else if (window.getSelection) {
      var selection = window.getSelection();
      var range = document.createRange();
      range.selectNodeContents(text);
      selection.removeAllRanges();
      selection.addRange(range);
    } else {
    }
  }
  $('.comment-list pre').each(function() {
    $(this).prepend('<i class="copy icon"></i>');
  });
  $('.topic-content pre').each(function() {
    $(this).prepend('<i class="copy icon"></i>');
  });
  $('.comment-list, .topic-content').on('click', 'i.copy', function (e) { // 复制代码
    var target = $(e.target);
    selectText(target.parent()[0]);
    try {
      var success = document.execCommand('copy');
      if (success) {
        util.show(i18n('copy.success'), 'success');
      }
    } catch (e) {
    }
  });

  var ttype = pageConfig.topic.type;
  if (myid && (ttype === 'question' || ttype === 'widget') && (isAdmin || isMyself) && !pageConfig.topic.answer) {
    $('.comment-list').on('mouseover', '.comment-content', function (e) {
      var list = $(e.target).closest('li');
      $('.current-answer.show').removeClass('show');
      list.children('.list-item').children('.comment-edit-wrap').find('.current-answer').addClass('show');
    }).on('mouseleave', '.comment-item', function () {
      $('.current-answer.show').removeClass('show');
    }).on('click', '.current-answer', function (e) {
      $(e.target).parent().find('.answer').click();
    });
  }

  if (pageConfig.topic.answer) {
    $('.comment-list').eq(0).removeClass('hide').html( answered);
    $('.comment-list-title').eq(0).removeClass('hide');
  }
})();


require('../../app/markdown');
require('../../app/switch')(editorId); 



var shareMap = {
  sina: ['http://service.weibo.com/share/share.php', 'title', 'url', 'pic'],
  douban: ['https://www.douban.com/share/service', 'name', 'href', 'image'],
  qzone: ['http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey', 'title', 'url', 'pics']
}

$('.share > a').click( function (e) {
  e.preventDefault();
  var type = $(e.target).closest('a').attr('share-type');
  if (type === 'weixin') {
    require.ensure(["./qrcode"], function(require) {
      var qrcode = require('./qrcode');
      qrcode.show();
    }, 'qrcode');
  } else {
    var encode = encodeURIComponent;
    var arr = shareMap[type];
    var url = arr[0] + '?' + arr[1] + '=' + encode(pageConfig.topic.title) + '&' + arr[2] + '=' + encode(location.href);
    window.open(url);
  }
});



gotoTop($('#back-to-top'));
$('#go-to-comment').click(function () {
  $('.editor-wrap')[0].scrollIntoView()
})




// WEBPACK FOOTER //
// ./src/pages/topic/topic.js